import { useEffect } from 'react';

export const usePageMeta = (title: string, description?: string, imageUrl?: string) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const setMeta = (selector: string, attr: 'name' | 'property', value: string, content: string) => {
      let tag = document.querySelector<HTMLMetaElement>(`meta[${attr}="${value}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, value);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    if (description) {
      setMeta('meta[name="description"]', 'name', 'description', description);
      setMeta('meta[property="og:description"]', 'property', 'og:description', description);
      setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
    }

    if (title) {
      setMeta('meta[property="og:title"]', 'property', 'og:title', title);
      setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
    }

    // Image - use provided or default public/og-image.png
    const resolvedImage = imageUrl || `${window.location.origin}/asknow.webp`;
    setMeta('meta[property="og:image"]', 'property', 'og:image', resolvedImage);
    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', resolvedImage);
  }, [title, description, imageUrl]);
};


